(() => {
  "use strict";
  document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("js-sidebar")) {
      var a = new StickySidebar("#js-sidebar", {
        topSpacing: 100,
        bottomSpacing: 100,
        containerSelector: "#js-content",
        innerWrapperSelector: "#js-sidebar-inner",
      });
    }
  });
})();
